(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanoun-find-your-ritual"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sanoun-finder]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const quiz = root.querySelector('[data-sanoun-quiz]');
      if (!quiz) return;

      const state = {};
      const progress = quiz.querySelector('[data-sanoun-progress]');
      const result = quiz.querySelector('[data-sanoun-result]');
      const announcement = quiz.querySelector('[data-sanoun-announcement]');
      const questionTwo = quiz.querySelector('[data-sanoun-question-two]');
      const questionThree = quiz.querySelector('[data-sanoun-question-three]');
      const answersTwo = quiz.querySelector('[data-sanoun-answers-two]');
      const answersThree = quiz.querySelector('[data-sanoun-answers-three]');

      const questionTwoOptions = {
        skin: [
          ['rich', 'Rich moisture that lasts'],
          ['simple', 'Simple care with one ingredient'],
          ['travel', 'A small size to try or travel with']
        ],
        hands: [
          ['everyday', 'Everyday moisture after washing'],
          ['rich', 'Care for hands, nails, and cuticles'],
          ['simple', 'Simple care with one ingredient']
        ],
        hair: [
          ['butter', 'Rich moisture for strands and ends'],
          ['oil', 'Something lighter'],
          ['simple', 'Simple care with one ingredient']
        ],
        everything: [
          ['multipurpose', 'One multipurpose product'],
          ['try', 'One small product to try'],
          ['complete', 'A set with several products']
        ]
      };

      const scentOptions = [
        ['bare', 'Bare, with no added fragrance'],
        ['warm', 'Warm and soft'],
        ['calm', 'Fresh and herbal'],
        ['none', 'I have no preference']
      ];

      const hairPorosityOptions = [
        ['low', 'They sit on top or build up easily'],
        ['medium', 'They sink in at a steady pace'],
        ['high', 'They disappear quickly and my hair feels dry again'],
        ['unsure', 'I am not sure']
      ];

      const hairOilOptions = [
        ['hairline', 'My scalp and hairline'],
        ['strands', 'My strands and ends'],
        ['both', 'Both'],
        ['unsure', 'I am not sure']
      ];

      const emit = (name, detail = {}) => {
        root.dispatchEvent(new CustomEvent('sanoun:ritualFinder', { bubbles: true, detail: { name, ...detail } }));
      };

      const showStep = (number) => {
        quiz.querySelectorAll('[data-sanoun-step]').forEach((step) => {
          step.hidden = step.dataset.sanounStep !== String(number);
        });
        result.hidden = true;
        progress.hidden = false;
        progress.textContent = `Question ${number} of 3`;
        const heading = quiz.querySelector(`[data-sanoun-step="${number}"] h3`);
        if (heading) heading.focus({ preventScroll: true });
      };

      const renderOptions = (container, options, step) => {
        container.replaceChildren();
        options.forEach(([value, label]) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.sanounAnswer = value;
          button.dataset.sanounDynamicStep = String(step);
          button.textContent = label;
          container.appendChild(button);
        });
      };

      const questionThreeOptions = () => {
        if (state.need !== 'hair') {
          questionThree.textContent = 'How do you want your ritual to smell on you?';
          return scentOptions;
        }
        if (state.mode === 'butter' || state.mode === 'simple') {
          questionThree.textContent = 'What happens when you use rich products?';
          return hairPorosityOptions;
        }
        if (state.mode === 'oil') {
          questionThree.textContent = 'Where do you want to focus?';
          return hairOilOptions;
        }
        questionThree.textContent = 'What should we account for?';
        return [['bare', 'No added fragrance'], ['none', 'No preference']];
      };

      const recommendationKey = () => {
        if (state.need === 'skin') {
          if (state.mode === 'simple' || state.preference === 'bare') return 'raw-shea';
          if (state.mode === 'travel') return 'mini-shea';
          if (state.preference === 'calm') return 'lafia-body';
          if (state.preference === 'warm') return 'vanilla-body';
          return 'raw-shea';
        }
        if (state.need === 'hands') {
          if (state.mode === 'simple' || state.preference === 'bare') return 'mini-shea';
          if (state.preference === 'calm') return 'lafia-hand';
          if (state.preference === 'warm') return 'vanilla-hand';
          return state.mode === 'rich' ? 'raw-shea' : 'vanilla-hand';
        }
        if (state.need === 'hair') {
          if (state.mode === 'oil') return 'hair-oil';
          if (state.mode === 'simple') return 'raw-shea';
          return 'hair-butter';
        }
        if (state.mode === 'try') return 'mini-shea';
        if (state.mode === 'multipurpose') return 'raw-shea';
        if (state.preference === 'warm') return 'vanilla-ritual';
        if (state.preference === 'calm') return 'lafia-ritual';
        return 'sarata';
      };

      const personalNote = () => {
        if (state.need !== 'hair') return '';
        if (state.mode === 'butter' || state.mode === 'simple') {
          if (state.preference === 'low') return 'For leave-in, start with ¼ teaspoon. You can also use it as a gently warmed pre-wash mask.';
          if (state.preference === 'medium') return 'Start with ½ teaspoon on damp strands and observe before adding more.';
          if (state.preference === 'high') return 'Start with 1 teaspoon on damp strands to help seal in moisture. Add a little Hair Oil as needed.';
          return 'Start small on damp strands and observe how your hair responds.';
        }
        if (state.mode === 'oil') {
          if (state.preference === 'hairline') return 'Massage a few drops gently along the scalp and hairline as part of a consistent ritual.';
          if (state.preference === 'strands') return 'Smooth a few drops over damp strands and ends, then observe before adding more.';
          if (state.preference === 'both') return 'Start with a few drops. Massage the scalp first, then smooth what remains over strands and ends.';
        }
        return '';
      };

      const showResult = () => {
        const key = recommendationKey();
        const source = root.querySelector(`[data-sanoun-result-source="${key}"]`);
        result.replaceChildren();
        if (source) result.appendChild(source.content.cloneNode(true));

        const note = result.querySelector('[data-sanoun-personal-note]');
        const noteText = personalNote();
        if (note && noteText) {
          note.textContent = noteText;
          note.hidden = false;
        }

        const restart = document.createElement('button');
        restart.type = 'button';
        restart.className = 'sanoun-finder__restart';
        restart.textContent = 'Start over';
        restart.addEventListener('click', () => {
          Object.keys(state).forEach((keyName) => delete state[keyName]);
          announcement.textContent = '';
          showStep(1);
          quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
          emit('finder_restarted');
        });
        result.appendChild(restart);

        progress.hidden = true;
        quiz.querySelectorAll('[data-sanoun-step]').forEach((step) => { step.hidden = true; });
        result.hidden = false;
        const title = result.querySelector('h3');
        announcement.textContent = title ? `Your recommendation is ${title.textContent}.` : 'Your recommendation is ready.';
        if (title) title.focus({ preventScroll: true });
        emit('recommendation_shown', { recommendation: key });

        const resultLink = result.querySelector('[data-sanoun-result-link]');
        if (resultLink) resultLink.addEventListener('click', () => emit('recommendation_clicked', { recommendation: key }), { once: true });
      };

      quiz.addEventListener('click', (event) => {
        const answer = event.target.closest('[data-sanoun-answer]');
        const back = event.target.closest('[data-sanoun-back]');

        if (back) {
          showStep(back.dataset.sanounBack);
          return;
        }
        if (!answer) return;

        const step = answer.closest('[data-sanoun-step]');
        if (!step) return;

        if (step.dataset.sanounStep === '1') {
          state.need = answer.dataset.sanounAnswer;
          questionTwo.textContent = 'What would help most?';
          renderOptions(answersTwo, questionTwoOptions[state.need], 2);
          showStep(2);
          emit('question_completed', { question: 1 });
          emit('finder_started');
          return;
        }

        if (step.dataset.sanounStep === '2') {
          state.mode = answer.dataset.sanounAnswer;
          renderOptions(answersThree, questionThreeOptions(), 3);
          showStep(3);
          emit('question_completed', { question: 2 });
          return;
        }

        state.preference = answer.dataset.sanounAnswer;
        emit('question_completed', { question: 3 });
        showResult();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
